import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["searchInput", "programFilter", "courseRow", "filterEmpty", "visibleCount"];

  connect() {
    this.filterRows();
  }

  selectedProgram() {
    return this.element.dataset.programFilter || "programs";
  }

  rowMatchesProgram(row, program) {
    const courseProgram = row.dataset.courseProgram;

    if (program === "all") return true;
    if (program === "programs") {
      return courseProgram === "residency" || courseProgram === "clinical";
    }

    return courseProgram === program;
  }

  filterRows() {
    const query = this.hasSearchInputTarget
      ? this.searchInputTarget.value.trim().toLowerCase()
      : "";
    const program = this.selectedProgram();
    let visibleCount = 0;

    this.courseRowTargets.forEach((row) => {
      const matchesProgram = this.rowMatchesProgram(row, program);
      const haystack = row.dataset.searchText || "";
      const matchesSearch = !query || haystack.includes(query);
      const visible = matchesProgram && matchesSearch;

      row.classList.toggle("hidden", !visible);
      if (visible) visibleCount += 1;
    });

    if (this.hasFilterEmptyTarget) {
      this.filterEmptyTarget.classList.toggle("hidden", visibleCount > 0);
    }

    if (this.hasVisibleCountTarget) {
      this.visibleCountTarget.textContent = String(visibleCount);
    }
  }

  searchChanged() {
    this.filterRows();
  }

  setProgramFilter(event) {
    event.preventDefault();
    const value = event.currentTarget.dataset.programFilterValue;
    this.element.dataset.programFilter = value;

    this.programFilterTargets.forEach((button) => {
      button.classList.toggle(
        "active",
        button.dataset.programFilterValue === value
      );
    });

    this.filterRows();
  }
}
